import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
    allPracticeDrill,
    fetchPracticeDrill,
    deletePracticeDrill
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateItems from './component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class practicedrill extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            adddiv:false,
            editdiv:false,
            lsttype:[], 
            selshot:'',
            seltype:'',
            seldrill:'',
            eid:'',            
         
         };    

         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

    UNSAFE_componentWillMount() {
	   this.props.allPracticeDrill();
	}


    onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true,
      });
    } 
      
    onBackSection() {
		this.setState({ 
         adddiv:false,
         viewdiv:true,
         editdiv:false,

       });
	}  


    editAssessment(gid){
        this.props.fetchPracticeDrill(gid).then((data) => {   
            var resdata=data.data;
            var lstype= resdata.type;
            var details=resdata.details;
            this.setState({ 
                lsttype:lstype,
                eid:details[0].gpdID,
                selshot:details[0].gpd_shotID,
                seltype:details[0].gpd_sheadID,
                seldrill:details[0].gpd_desc       
              });
              
            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                editdiv:true,
       
              });

        });
    }

    deleteForm(data){
      this.data = data;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deletePracticeDrill(this.data);
            this.data = ""
        }
    }

    render() {
       const { match, practicedrilllist, loading } = this.props;
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "shot", label: "SHOT" },
            { name: "type", label: "TYPE" },
            { name: "dill", label: "DRILL" },
            { name: "action", label: "ACTION" },
            { name: "action1", label: "ACTION1" },
          
        ];
        const tabledata=practicedrilllist.map((assmntval,idx) => {     
                     const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.gpdID)}><EditOutlinedIcon/></IconButton>;
                     const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.gpdID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                no:idx+1,
                shot: assmntval.gps_shot,
                type: assmntval.gpsh_name,
                dill:assmntval.gpd_desc,
                action: ebtn,
                action1:dbtn,
                
                }
        });

 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Practics Drill | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.practicedrill" />} match={match} />
             
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-md-12">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Drill</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                 <AddItem onClick={this.onBackSection} />
               }

               {this.state.editdiv && 
                 <UpdateItems onClick={this.onBackSection} data={this.state} />
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'practice drill'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ practicedrill }) => {
	const { practicedrilllist, loading } = practicedrill;
	return { practicedrilllist, loading };
}

export default connect(mapStateToProps, {
    allPracticeDrill,
    fetchPracticeDrill,
    deletePracticeDrill
})(practicedrill); 